import axios from "axios";

let affiliateSvc = process.env.VUE_APP_COMPANY_API_URL;
let companyRoot = process.env.VUE_APP_COMPANY_USER_ROOT;

axios.defaults.headers.common["api_key"] =
	process.env.VUE_APP_CARD_USER_API_KEY;

const supportAxiosinstance = axios.create({
	baseURL: affiliateSvc,
});

export default {
	financeService: {
		searchClientMandates(queryParams, token) {
			return supportAxiosinstance.get(
				companyRoot +
				"/v1/accounting/direct-debit/mandates" + queryParams,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},
		getClientMandateDetails(mandateId, token) {
			return supportAxiosinstance.get(
				companyRoot +
				"/v1/accounting/direct-debit/mandates/" + mandateId,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},
		getReportTypes(token) {
			return supportAxiosinstance.get(
				companyRoot +
				"/v1/accounting/direct-debit/reports/types",
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},
		searchClientPayments(queryParams, token) {
			return supportAxiosinstance.get(
				companyRoot +
				"/v1/accounting/direct-debit/invoices" + 
				queryParams,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},
		uploadBankReport(bankReport,  token) {
			return supportAxiosinstance.post(
				companyRoot +
				"/v1/accounting/direct-debit/reports",
				bankReport,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},
		getClientInvoiceDetails(mandateId, token) {
			return supportAxiosinstance.get(
				companyRoot +
				"/v1/accounting/direct-debit/invoices/" + mandateId,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},
	},
};
